export const getYearList = (count = 5) => {
  // Generate last N years dynamically
  const currentYearNum = new Date().getFullYear()
  const options = Array.from({ length: count }, (_, i) => {
    const year = '' + (currentYearNum - i)
    return { value: year, label: year, key: year }
  })

  return {
    yearList: options,          // array of { value, label, key } objects
    year: '' + currentYearNum,  // selected year (latest)
    period: 'YEAR'              // default period
  }
}

export const getFinancialYearList = (count = 5) => {
  const today = new Date()
  const currentYear = today.getFullYear()
  const currentMonth = today.getMonth() // 0-indexed: 0 = Jan, 3 = Apr
  const startFY = currentMonth >= 3 ? currentYear : currentYear - 1

  const options = Array.from({ length: count }, (_, i) => {
    const start = startFY - i
    const end = start + 1
    const value = `${start}-${end}`
    const label = i === 0 ? `${start}-YTD` : `${start}-${end}`
    return { value, label, key: value }
  })

  return {
    financialYearList: options,
    financialYear: options[0].value,
  }
}